import Repository from '../Repository';
import {empty} from "../../../shared/utils";

const resource = 'newsletter/listing';

export default {
    get() {
        return Repository.get(resource)
    },
    getListing(listingId) {
        return Repository.get(resource + '/'+ listingId)
    },
    createListing(payload) {
        return Repository.post(resource, payload)
    },
    updateListing(listingId, payload) {
        return Repository.put(resource + '/' + listingId, payload)
    },
    exportListing(listingId) {
        return Repository.get(resource + '/'+ listingId +'/export')
    },
    searchListing(search) {
        let query = '?'

        if (!empty(search.name)) {
            query += '&name='+search.name
        }

        if (!empty(search.type)) {
            query += '&types[]=' + search.type
        }

        if (!empty(search.status)) {
            query += '&status[]=' + search.status
        }

        if (!empty(search.id)) {
            query += '&ids[]=' + search.id
        }

        if (!empty(search.personEmail)){
            query += '&personEmails[]=' + search.personEmail
        }

        if (!empty(search.limit)) {
          query += '&limit='+search.limit
        }

        if (!empty(search.page)) {
          query += '&page='+search.page
        }

        return Repository.get(resource + query);
    }
}
